import React, { createContext, useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

export const AppContext = createContext(null)

const AppContextProvider = (props) => {
  const location = useLocation()
  console.log('Location Pathname:', location.pathname)

  const getDefaultTicketCount = () => {
    if (location.pathname.startsWith('/buy')) {
      return parseInt(process.env.REACT_APP_BUY_ROUTE_TICKET_DEFAULT_AMOUNT, 10) || 1
    }
    return parseInt(process.env.REACT_APP_COLLECTION_ROUTE_TICKET_DEFAULT_AMOUNT, 10) || 1
  }

  const [ticketCount, setTicketCount] = useState(getDefaultTicketCount())
  const [lotteryState, setLotteryState] = useState(null)
  const [packageState, setPackageState] = useState(null)
  const [salesType, setSalesType] = useState(null)
  const [ticketIds, setTicketIds] = useState(null)
  const [site, setSite] = useState('')

  useEffect(() => {
    setTicketCount(getDefaultTicketCount())
  }, [location.pathname])

  const valueProvider = useMemo(() => ({
    lotteryState,
    setLotteryState,
    packageState,
    setPackageState,
    salesType,
    setSalesType,
    ticketIds,
    setTicketIds,
    ticketCount,
    setTicketCount,
    site,
    setSite
  }), [lotteryState, packageState, salesType, ticketIds, ticketCount, site])

  return (
    <AppContext.Provider value={valueProvider}>
      {props.children}
    </AppContext.Provider>
  )
}

AppContextProvider.propTypes = {
  children: PropTypes.element
}

export default AppContextProvider
